import React, { useState, useEffect } from 'react';
import "./interactive-question.css";

function InteractiveQuestion({ questionProp, answerProp, topicProp, triggerAvatarCorrect, triggerAvatarRevealAnswer, onAnswered }) {
  const [inputValue, setInputValue] = useState("");
  const [feedbackType, setFeedbackType] = useState(null); // "correct" | "reveal" | null
  const [submitted, setSubmitted] = useState(false);
  const [checking, setChecking] = useState(false);
  const [answerImageUrl, setAnswerImageUrl] = useState("");
  const [answerExplanation, setAnswerExplanation] = useState("");

  useEffect(() => {
    setInputValue("");
    setFeedbackType(null);
    setSubmitted(false);
    setChecking(false);
    setAnswerImageUrl("");
    setAnswerExplanation("");
  }, [questionProp, answerProp]);

  const handleSubmit = async () => {
    if (!inputValue.trim() || submitted || checking) return;

    setChecking(true);

    let isCorrect = false;
    let imageUrl = "";
    let explanation = "";

    try {
      const token = localStorage.getItem("google_token");
      const response = await fetch(
        `https://plato-vm.westus.cloudapp.azure.com:5001/Transcript/CheckAnswerWithExplanation?userAnswer=${encodeURIComponent(inputValue.trim())}&correctAnswer=${encodeURIComponent((answerProp || "").trim())}&question=${encodeURIComponent((questionProp || "").trim())}&topic=${encodeURIComponent((topicProp || "").trim())}`,
        {
          method: "GET",
          headers: { "Authorization": `Bearer ${token}` }
        }
      );
      const data = await response.json();
      isCorrect = data.isCorrect;
      imageUrl = data.imageUrl || "";
      explanation = data.explanation || "";
    } catch {
      // Fallback to local comparison if API fails
      isCorrect = inputValue.trim().toLowerCase() === (answerProp || "").trim().toLowerCase();
    } finally {
      setChecking(false);
    }

    setAnswerImageUrl(imageUrl);
    setAnswerExplanation(explanation);

    if (isCorrect) {
      setFeedbackType("correct");
      triggerAvatarCorrect(explanation);
    } else {
      setFeedbackType("reveal");
      triggerAvatarRevealAnswer(answerProp, explanation);
    }

    setSubmitted(true);
    if (onAnswered) onAnswered(isCorrect);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !submitted && !checking) {
      handleSubmit();
    }
  };

  return (
    <div className="iq-container">
      <div className="iq-label">Quick Check</div>
      <div className="iq-question">{questionProp}</div>

      <input
        className="iq-input"
        type="text"
        placeholder="Type your answer…"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={submitted || checking}
      />

      {!submitted && (
        <button className="iq-submit-btn" onClick={handleSubmit} disabled={checking}>
          {checking ? "Checking…" : "Submit"}
        </button>
      )}

      {feedbackType === "correct" && (
        <div className="iq-feedback iq-feedback--correct">
          ✓&nbsp; Correct! Well done.
        </div>
      )}

      {(feedbackType === "correct" || feedbackType === "reveal") && (
        <div className="iq-answer-reveal">
          <span className="iq-answer-reveal-label">The answer is</span>
          <span className="iq-answer-reveal-value">{answerProp}</span>
        </div>
      )}

      {answerImageUrl && (
        <img
          className="iq-answer-image"
          src={answerImageUrl}
          alt="Visual for the answer"
        />
      )}

      {answerExplanation && (
        <div className="iq-answer-explanation">{answerExplanation}</div>
      )}
    </div>
  );
}

export default InteractiveQuestion;
